import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  /**
   * Copies the given text to the clipboard.
   *
   * @param {string} text the text to copy
   *
   * @returns {boolean} an observable emitting true if the copy succeeded, false otherwise
   */
  public copy(text: string): Observable<boolean> {
    return from(navigator.clipboard?.writeText(text) ?? Promise.reject()).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
